import { supabase } from "@/integrations/supabase/client";
import { hasAnalyticsConsent } from "@/lib/consent";

const SESSION_KEY = "cf_session_id";

function getSessionId(): string {
  let id = sessionStorage.getItem(SESSION_KEY);
  if (!id) {
    id = crypto.randomUUID();
    sessionStorage.setItem(SESSION_KEY, id);
  }
  return id;
}

/**
 * Track a funnel / conversion event.
 * Fire-and-forget: never blocks UI, never throws.
 */
export function trackEvent(eventName: string, eventData?: Record<string, any>) {
  // Respect user cookie/analytics consent (Consent Mode v2)
  if (!hasAnalyticsConsent()) return;
  try {
    const row: any = {
      event_name: eventName,
      event_data: eventData ?? {},
      page_path: window.location.pathname,
      referrer: document.referrer || null,
      user_agent: navigator.userAgent,
      session_id: getSessionId(),
    };

    supabase.from("analytics_events").insert([row]).then(() => {});

    // Forward to GA4 if present
    if (typeof window !== "undefined" && (window as any).gtag) {
      (window as any).gtag("event", eventName, eventData);
    }
  } catch {
    // silent – analytics must never break the app
  }
}
